// Staff-facing error screen: camera denied, lost, or unavailable. One retry
// button, which is also the user gesture iOS needs to ask for the camera
// again. Slate palette from the design pass: deliberately not the visitor look.
import { t, onLanguageChange } from '../i18n/index.js';
import { el } from '../debug/controls.js';
import { ICON_RETRY } from './icons.js';

export function createErrorScreen(app, { onRetry, detail = () => '' }) {
  let kind = 'lost';
  const eyebrow = el('p', { class: 'staff__eyebrow', text: 'Staff · magic-window' });
  const title = el('h1', { class: 'staff__title' });
  const body = el('p', { class: 'staff__body' });
  const detailEl = el('p', { class: 'staff__detail' });
  const retryLabel = el('span');
  const retry = el('button', { class: 'retry', type: 'button' }, [retryLabel]);
  retry.insertAdjacentHTML('afterbegin', ICON_RETRY);
  const panel = el('div', { class: 'staff staff--error' }, [eyebrow, title, body, detailEl, retry]);
  const root = el('div', { class: 'mw-staff-layer' }, [panel]);
  root.hidden = true;

  const render = () => {
    const key = ['denied', 'unsupported'].includes(kind) ? kind : 'lost';
    title.textContent = t(`error.${key}.title`);
    body.textContent = t(`error.${key}.body`);
    retryLabel.textContent = t('error.retry');
    detailEl.textContent = detail();
  };
  render();
  onLanguageChange(render);

  retry.addEventListener('pointerdown', () => retry.classList.add('is-pressed'));
  for (const type of ['pointerup', 'pointercancel', 'pointerleave']) {
    retry.addEventListener(type, () => retry.classList.remove('is-pressed'));
  }
  retry.addEventListener('click', () => onRetry());

  app.append(root);
  return {
    show: (nextKind) => {
      kind = nextKind;
      render();
      root.hidden = false;
    },
    hide: () => (root.hidden = true),
    get visible() {
      return !root.hidden;
    },
  };
}
